<template>
  <v-card class="mx-auto" max-width="600">
    <v-app-bar color="accent" dark rounded flat>
      <v-toolbar-title>{{ form.title }}</v-toolbar-title>
    </v-app-bar>
    <v-card-text>
      <v-form ref="group_form">
        <v-text-field :counter="30" label="グループ名" required v-model="group.groupName" dense class="my-3" :rules="[rules.required, rules.max30]"></v-text-field>
        <v-textarea :counter="100" label="募集要項" v-model="group.groupRequirements" class="my-3" dense :rules="[rules.required, rules.max100]"></v-textarea>
        <div class="text-right">
          <v-btn color="secondary" outlined class="ml-2" @click="resetValidate()">閉じる</v-btn>
          <v-btn color="accent" class="ml-2" @click="createGroup">{{ form.buttonText }}</v-btn>
        </div>
      </v-form>
    </v-card-text>
  </v-card>
</template>
<script>
import {mapActions,mapGetters} from 'vuex'
export default {
  name: 'GroupForm',
  props: {
    editGroup: Object,
    form: {
      title: String,
      subTitle: String,
      buttonText: String
    }
  },
  computed:{
    ...mapGetters(['loginUserId','myGroups'])
  },
  created(){
    if(this.editGroup){
      if(this.editGroup.groupId){
        this.group = this.editGroup;
      }
    }
  },
  methods: {
    // グループを作成する
    createGroup(){
      if(this.$refs.group_form.validate()){
      // グループIDがなければ新規作成
      if(!this.group.groupId){
        this.group.groupLeaderUserId = this.loginUserId;
        this.group.groupStatus = 1;
        this.addGroup(this.group)
        this.group = {}
      }else{
      // グループIDがあれば編集
        this.updateMyGroupConfrim();
      }
      this.toggleGroupFormModal();
      this.$refs.group_form.resetValidation()
      }
    },
    resetValidate(){
      this.$refs.group_form.resetValidation()
      this.toggleGroupFormModal();
    },
    updateMyGroupConfrim(){
      if(confirm("本当にグループを編集しますか？")){
        this.updateMyGroup(this.group)
      }
    },
   ...mapActions(['toggleGroupFormModal','addGroup','updateMyGroup'])
  },
  data(){
    return{
      valid: true,
      // 入力値を入れる空のオブジェクト
      group:{},
      rules: {
       required: v => !!v || '必須', 
       max30: v => (v || '').length <= 30 || '最大30文字',
       max100: v => (v || '').length <= 100 || '最大100文字',
       min1: v => v >= 1 || '1回以上'
      },
    }
  }
}
</script>